<template>
  <v-row
    no-gutters
  >
    <v-col
      cols="12"
    >
      <h1
        class="text-center text-h3 text-md-h2 text-lg-h1"
        style="font-family: 'Ubuntu', sans-serif !important;"
      >
        <span class="d-inline-block">Find the</span>
        <span class="d-inline-block">{ Ghost } .</span>
      </h1>
      <v-container
        class="mt-12 px-12 body-1"
      >
        <section>
          <p>
            Ureidea のミッションは「全てのビジネスを効率的に」することです。
          </p>
          <p>
            ビジネスには様々な課題があり、効率的と一口に言ってもその内容は多岐に渡ります。
          </p>
          <p
            class="mb-0"
          >
            Ureidea は、そこに見えている問題だけでなく、「ゴースト」のような見えていない非効率に対しても<br>
            積極的に気付き、解決できるようにすることを目指しています。
          </p>
        </section>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'MessageSection',
};
</script>
